import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    public dashboardRows = [
        { id: 'research', widgets: ['research.graph', 'research'] },
        { id: 'support', widgets: ['notice', 'ticketing'] },
        { id: 'community', widgets: ['board', 'manual'] }
    ];
    private managementView = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, '/login');
        await this.service.render();
    }

    public trackRow(_index: number, row: any) { return row.id; }
    public trackWidget(_index: number, widget: string) { return widget; }

    public ticketContext(direction: string | null) {
        const management = direction === 'received' || direction === 'all';
        if (management === this.managementView) return;
        this.managementView = management;
        const support = this.dashboardRows.find(row => row.id === 'support');
        support.widgets = management ? ['ticketing', 'notice'] : ['notice', 'ticketing'];
        const order = management ? ['support', 'research', 'community'] : ['research', 'support', 'community'];
        this.dashboardRows = order.map(id => this.dashboardRows.find(row => row.id === id));
    }
}

export default PageDashboardComponent;